// Case/AssignedCasesPage.tsx
import { CasesListView } from '../Cases/Components/CasesListView';
import { CASE_STATUS } from '../caseStatusIds';

/** Admin view of every case sitting at "Assigned" — awaiting the leader's accept/decline. */
export default function AssignedCasesPage() {
  return (
    <CasesListView
      fixedStatusID={CASE_STATUS.Assigned}
      title="Assigned Cases"
      subtitle="Cases assigned to a leader, awaiting their acceptance"
    />
  );
}
